import { GET_LOGIN, GET_OTP , GET_ADDMAGICTOKEN, GET_VERIFYMAGICTOKEN, GET_COUNTRYCODE} from "resources/actionTypes";

export function getLogin(userLogin, navigate, setOnOtp) {
  const data = {
    loginPayload: userLogin,
    navigate: navigate,
    setOnOtp: setOnOtp
  };
  return {
    type: GET_LOGIN.GET_LOGIN_REQUESTED,
    payload: data,
  };
}

export function getOtp(userOtp, navigate, otpActions) {
  const data = {
    userOtp: userOtp,
    navigate: navigate,
    otpActions: otpActions
  };
  return {
    type: GET_OTP.GET_OTP_REQUESTED,
    payload: data,
  };
}


export function addMagicToken(userMagicToken) {
  const data = {
    userMagicToken:userMagicToken
  }
  return {
    type: GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_REQUESTED,
    payload: data,
  };
}

export function verifyMagicToken(userVerifyMagicToken,navigate) {
  const data = {
    userVerifyMagicToken:userVerifyMagicToken,
    navigate:navigate
  }
  return {
    type: GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_REQUESTED,
    payload: data,
  };
}

export function getCountryCode() {
  return {
      type: GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED
  }
}